export function buildIssueScannerQueryParams({
    categories = [],
    dateRange = null,
    clientId = null,
    clientContactId = null,
    picId = null,
    vendorId = null,
    assignedUser = null,
    assignedUserEmail = null,
} = {}) {
    const params = new URLSearchParams();

    if (categories.length > 0) {
        params.append("categories", categories.join(","));
    }

    if (dateRange) {
        params.append("startDate", dateRange.startDate);
        params.append("endDate", dateRange.endDate);
    }

    if (clientId) params.append("client_id", clientId);
    if (clientContactId) params.append("clientPic", clientContactId);
    if (picId) params.append("pic_id", picId);
    if (vendorId) params.append("vendor", vendorId);
    if (assignedUser) params.append("assigned_user", assignedUser);
    if (assignedUserEmail) params.append("assigned_user_email", assignedUserEmail);

    return `?${params.toString()}`;
}
